import React from "react";
import { NewTab, PageTab } from "../../../../../components";

const PageTabList = () => {
  const tabList = [
    {
      title: "Tab 1",
      page: <Tab1 />,
      type: "main",
    },
    {
      title: "Tab 2",
      page: <Tab2 />,
      type: "main",
    },
    {
      title: "Tab 3",
      page: <Tab3 />,
      type: "main",
    },
  ];

  const tabListWithValue = [
    {
      title: "Tab 1",
      page: <Tab1 />,
      type: "main",
      value: "20",
    },
    {
      title: "Tab 2",
      page: <Tab2 />,
      type: "main",
      value: "10",
    },
    {
      title: "Tab 3",
      page: <Tab3 />,
      type: "main",
      value: "48",
    },
  ];

  return (
    <div className="my-5 flex flex-col gap-5">
      <NewTab tabs={tabList} color="black" variant="text" />
      <NewTab tabs={tabList} />
      <NewTab
        tabs={tabList}
        color="black"
        variant="text"
        activeVariant="text"
      />
      <NewTab
        tabs={tabListWithValue}
        color="black"
        variant="text"
        activeVariant="text"
      />
    </div>
  );
};

export default PageTabList;

const Tab1 = () => {
  return <div className="my-2">Tab-1</div>;
};
const Tab2 = () => {
  return <div className="my-2">Tab-2</div>;
};
const Tab3 = () => {
  return <div className="my-2">Tab-3</div>;
};
